import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';

export const ImageHeaderContainer = styled.div`
    height: ${SIZE.THIRTY}px;
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    position: relative;
    overflow: hidden;
`
export const MainImageContainer = styled.div`
    display:flex;
    grid-column-start: 1;
    grid-column-end: 1;
    grid-row-start: 1;
    grid-row-end: 3;
`

export const SecondaryImageContainer = styled.div`
    display: flex;
    grid-column-start: 2;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 1;
`

export const ThridImageContainer = styled.div`
    display: flex;
    grid-column-start: 2;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 2;
`

export const DisclaimerBanner = styled.div`
    position: absolute;
    bottom: 0;
    left:0;
    right:0;
    height: ${SIZE.FIVE}px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2;
    font-family: Rubik;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    align-items: center;
    display: flex;
    justify-content: center;
    box-shadow: inset -2px 2px 18px 1px #0c0b15;
    border-top: 1px solid #0c0b15;

`

export const Image = styled.img`
    display: flex;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
`